/**
 * 配列内の項目のカウント数を足し合わせる
 *
 * @param 配列
 *
 * @return オブジェクト
 */
/* eslint-disable */
const getIcon = function (i) {
  if (i === -1) return 'mdi mdi-help mdi-36px'
  else if (i === 0) return 'mdi mdi-message-reply mdi-36px'
  else if (i === 1) return 'mdi mdi-account-location mdi-36px'
  else if (i === 2) return 'mdi mdi-phone mdi-36px'
  else if (i === 3) return 'mdi mdi-home-circle mdi-36px'
  else if (i === 4) return 'mdi mdi-bell mdi-36px'
  else if (i === 5) return 'mdi mdi-forum mdi-36px'
  else if (i === 6) return 'mdi mdi-forum-outline mdi-36px'
  else if (i === 7) return 'mdi mdi-comment mdi-36px'
  else if (i === 8) return 'mdi mdi-comment-multiple mdi-36px'
  else if (i === 9) return ''
  else if (i === 10) return 'mdi mdi-help-circle mdi-36px'
  else if (i === 11) return 'mdi mdi-message-alert mdi-36px'
  else if (i === 12) return 'mdi mdi-contacts mdi-36px'
  else if (i === 13) return 'mdi mdi-gesture-double-tap mdi-36px'
  else if (i === 14) return 'mdi mdi-clipboard-check-outline mdi-36px'
  else if (i === 15) return 'mdi mdi-account-box-multiple mdi-36px'
  else if (i === 16) return 'mdi mdi-comment-question mdi-36px'
  else if (i === 17) return 'mdi mdi-comment-question-outline mdi-36px'
  else if (i === 18) return 'mdi mdi-robot mdi-36px'
  else if (i === 19) return 'mdi mdi-label-variant mdi-36px'
  else if (i === 20) return 'mdi mdi-label-variant-outline mdi-36px'
  else if (i === 21) return 'mdi mdi-emoticon mdi-36px'
  else if (i === 22) return 'mdi mdi-emoticon-happy mdi-36px'
  else if (i === 23) return 'mdi mdi-email mdi-36px'
  else if (i === 24) return 'mdi mdi-email-outline mdi-36px'
  else if (i === 25) return 'mdi mdi-information mdi-36px'
  else if (i === 26) return 'mdi mdi-information-outline mdi-36px'
  else if (i === 27) return 'mdi mdi-comment-account mdi-36px'
  else if (i === 28) return 'mdi mdi-comment-account-outline mdi-36px'
  else if (i === 29) return 'mdi mdi-comment-alert mdi-36px'
  else if (i === 30) return 'mdi mdi-comment-alert-outline mdi-36px'
  else if (i === 31) return 'mdi mdi-account-supervisor-circle mdi-36px'
  else if (i === 32) return 'mdi mdi-account-search mdi-36px'
  else if (i === 33) return 'mdi mdi-account-search-outline mdi-36px'
  else if (i === 34) return 'mdi mdi-account-star mdi-36px'
  else if (i === 35) return 'mdi mdi-home-modern mdi-36px'
  else if (i === 36) return 'mdi mdi-home-variant mdi-36px'
  else if (i === 37) return 'mdi mdi-home-map-marker mdi-36px'
  else if (i === 38) return 'mdi mdi-feature-search mdi-36px'
  else if (i === 39) return 'mdi mdi-feature-search-outline mdi-36px'
  else if (i === 40) return 'mdi mdi-file-find mdi-36px'
  else if (i === 41) return 'mdi mdi-table-search mdi-36px'
  else if (i === 42) return 'mdi mdi-script mdi-36px'
  else if (i === 43) return 'mdi mdi-login-variant mdi-36px'
  else if (i === 44) return 'mdi mdi-magnify mdi-36px'
  else return ''
}

export default getIcon



// WEBPACK FOOTER //
// ./src/functions/getIcon.js